import { useState, useEffect } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { WheelPicker } from "@/Components/WheelPicker";
import "./styles.scss";

type HeightUnit = "inch" | "cm";
type WeightUnit = "lb" | "kg";

interface PickerModalProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
  title: string;
  columns: Array<{ items: string[] }>;
  onChange: (values: string[]) => void;
  initialValues: string[];
  toggleUnits?: {
    value: string;
    onChange:
      | React.Dispatch<React.SetStateAction<HeightUnit>>
      | React.Dispatch<React.SetStateAction<WeightUnit>>;
    options: Array<{ value: string; label: string }>;
  };
}

const PickerModal: React.FC<PickerModalProps> = ({
  open,
  onClose,
  onCancel,
  title,
  columns,
  onChange,
  initialValues,
  toggleUnits,
}) => {
  const [unitKey, setUnitKey] = useState("default");
  const [okClicked, setOkClicked] = useState(false);

  useEffect(() => {
    setOkClicked(false);
  }, [open]);

  return (
    <Dialog.Root open={open} onOpenChange={(open) => !open && onCancel()}>
      <Dialog.Portal>
        <Dialog.Overlay className="modal-overlay" />
        <Dialog.Content
          className="modal-content"
          style={{ touchAction: "auto" }}
        >
          <Dialog.Title className="picker-modal-title h3">{title}</Dialog.Title>

          <div className="picker-modal-body">
            {toggleUnits && (
              /** TODO: replace MUI Toggle with Radix UI as we're removing MUI  */
              <ToggleButtonGroup
                value={toggleUnits.value}
                exclusive
                onChange={(_, value) => {
                  if (value && toggleUnits?.onChange) {
                    toggleUnits.onChange(value);
                    setUnitKey(value);
                  }
                }}
                aria-label="unit toggle"
                className="unit-toggle"
              >
                {toggleUnits.options.map((option) => (
                  <ToggleButton
                    key={option.value}
                    value={option.value}
                    className="unit-toggle-button"
                    disableRipple
                  >
                    {option.label}
                  </ToggleButton>
                ))}
                <span className="toggle-indicator"></span>
              </ToggleButtonGroup>
            )}
            {!okClicked && (
              <div className="wheel-picker-container">
                <WheelPicker
                  columns={columns}
                  onChange={onChange}
                  initialValues={initialValues}
                  key={unitKey}
                />
              </div>
            )}
          </div>

          <div className="picker-modal-footer">
            <button className="text-button" onClick={onCancel}>
              Cancel
            </button>
            <button
              className="primary-button"
              onClick={() => {
                setOkClicked(true);
                onClose();
              }}
            >
              Ok
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default PickerModal;
